import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { StickyTopBar } from './components/StickyTopBar';
import { Hero } from './components/Hero';
import { Testimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { TargetAudience } from './components/TargetAudience';
import { ProductOverview } from './components/ProductOverview';
import { Tomos } from './components/Tomos';
import { Bonos } from './components/Bonos';
import { Comparison } from './components/Comparison';
import { UrgencyBlock } from './components/UrgencyBlock';
import { Pricing } from './components/Pricing';
import { ProAddons } from './components/ProAddons';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen bg-[#F5F0E8]" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <StickyTopBar data-id="element-2" />
      <Hero data-id="element-3" />
      <Testimonials data-id="element-4" />
      <PainPoints data-id="element-5" />
      <TargetAudience data-id="element-6" />
      <ProductOverview data-id="element-7" />
      <Tomos data-id="element-8" />
      <Bonos data-id="element-9" />
      <Comparison data-id="element-10" />
      <UrgencyBlock data-id="element-11" />
      <Pricing data-id="element-12" />
      <ProAddons data-id="element-13" />
      <Guarantee data-id="element-14" />
      <FAQ data-id="element-15" />
      <FinalCTA data-id="element-16" />
      <Footer data-id="element-17" />
    </div>;
}